import client from "../index.js";
import { SEND_SMS } from "./mutation.js";

export const apiSendSms = ({ toPhone, body, from }) => {
  return client
    .mutate({
      mutation: SEND_SMS,
      variables: { input: { toPhone, body, ...(from ? { from } : {}) } },
      fetchPolicy: "no-cache",
    })
    .then((res) => res.data?.sendSms);
};
